//react
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAps';
import { useEffect } from 'react';
//import { OrderType } from 'types/order';

const AdfactoryTag = () => {
  const { isThanks } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const imgId = 'adfactory';
    const isExsistScript = document.getElementById(imgId);
    if (!!isExsistScript) isExsistScript.remove();

    if (isThanks) {
      const img = document.createElement('img');
      img.src = '//www.adfactory.io/adtr/cnv/ct?cid=31037&rid=%5BORDER_NUM%5D';
      img.id = imgId;
      img.setAttribute('width', '0');
      img.setAttribute('height', '0');
      document.body.appendChild(img);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return <></>;
};

export default AdfactoryTag;
